import { Component, Inject, forwardRef } from '@angular/core';
import { LayoutComponent } from '../../layout/layout.component';

@Component(
    {
        selector: 'unauthorized',
        templateUrl: './unauthorized.component.html',
        styleUrls: ['./unauthorized.component.css']
    }
)
export class UnAuthorizedComponent {
    constructor(private layoutComponent: LayoutComponent) {
        this.layoutComponent.showLoader = false;
    }
}
